import {
  BankAccountInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { Collapse } from 'antd';
import { useIntl } from 'react-intl';

export default function FinancialCashFlowMoreOptions() {
  const intl = useIntl().formatMessage;

  return (
    <Collapse style={{ margin: '8px 0 ' }}>
      <Collapse.Panel
        header={intl({ id: 'cashFlow.label.moreOptions' })}
        key={1}
      >
        <FloatingFormItem
          name="bankAccountIds"
          label={intl({ id: 'cashFlow.label.bankAccount' })}
        >
          <BankAccountInfiniteSelectField
            mode="multiple"
            queryFilter={{ active: true }}
          />
        </FloatingFormItem>
      </Collapse.Panel>
    </Collapse>
  );
}
